import { transport, BASE_PATH } from "@/src/config/apiConfig.js";

export default {
  async execute(entityType, entityId, eventType, updatedAttributes = [], executionPhase = "") {
    try {
      const payload = {
        entity_type: entityType,
        entity_id: String(entityId),
        event_type: eventType,
      };
      if (Array.isArray(updatedAttributes) && updatedAttributes.length > 0) {
        payload.updated_attributes = updatedAttributes;
      }
      if (executionPhase) {
        payload.execution_phase = executionPhase;
      }
      const res = await transport.post(
        `${BASE_PATH}/api/process-flows/execute`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing process flows: ", error);
      throw error;
    }
  },

  async submitExecution(executionId, formSubmission) {
    try {
      const res = await transport.post(
        `${BASE_PATH}/api/process-flows/executions/${executionId}/submit`,
        { form_submission: formSubmission },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while submitting execution: ", error);
      throw error;
    }
  },

  async resubmitForm(formId, entityType, entityId, formSubmission) {
    try {
      const res = await transport.post(
        `${BASE_PATH}/api/process-flows/resubmit-form`,
        {
          form_id: formId,
          entity_type: entityType,
          entity_id: entityId,
          form_submission: formSubmission,
        },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while resubmitting form: ", error);
      throw error;
    }
  },
};
